import { FullInvoice, getStatusConfig } from 'entities';
import { useRouteShare } from 'routes';

import { IconButton } from 'components/Blocks';
import { LinkIcon } from 'components/Icons';
import { useUser } from 'hooks';

export function InvoiceLink({ invoice }: { invoice: FullInvoice }) {
  const user = useUser();

  const shareInvoiceLink = useRouteShare('invoices');

  if (!user.team.isInvoiceTeam) return null;

  return (
    <IconButton
      tooltipContent="Copy Link"
      onClick={() =>
        shareInvoiceLink({
          invoice: invoice.id,
          status: getStatusConfig('invoice', invoice.status).queryParam,
        })
      }
    >
      <LinkIcon size={14} />
    </IconButton>
  );
}
